<template>
 	<b-navbar toggleable="lg" type="dark" :variant="navbarVariant" fixed="top" :style="navbarStyle">
		<b-navbar-brand to="/">
			<b-img :src="env.COMPANY_APP_URL + '/storage/images/images/logo/logo.png'" height="27px"></b-img>
			<!-- {{ env.COMPANY_APP_NAME }} -->
		</b-navbar-brand>

		<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

		<b-collapse id="nav-collapse" is-nav>
      		<b-navbar-nav>
                <b-nav-item-dropdown id="inventory" v-if="$can('view-inventory') || $can('view-all')" text="INVENTORY" no-caret>
                    <b-dropdown-item v-if="$can('view-products') || $can('view-all')" to="/inventory/products">Products</b-dropdown-item>
                    <b-dropdown-item v-if="$can('view-categories') || $can('view-all')" to="/inventory/categories">Categories</b-dropdown-item>
                    <b-dropdown-item v-if="$can('view-attributes') || $can('view-all')" to="/inventory/attributes">Attributes</b-dropdown-item>
                    <!-- <b-dropdown-item v-if="$can('view-tags') || $can('view-all')" to="/inventory/tags">Tags</b-dropdown-item> -->
                    <b-dropdown-item v-if="$can('view-generate-picture-file') || $can('view-all')" to="/inventory/generate-picture-file">Generate Picture File</b-dropdown-item>
                    <!-- <b-dropdown-item v-if="$can('view-quantity-update') || $can('view-all')" to="/inventory/quantity-update">Quantity Update</b-dropdown-item> -->
                </b-nav-item-dropdown>

                <b-nav-item-dropdown id="orders" v-if="$can('view-orders') || $can('view-all')" text="ORDERS" no-caret>
                    <b-dropdown-item v-if="$can('view-sales-orders') || $can('view-all')" to="/orders/sales-orders">Sales Orders</b-dropdown-item>
                    <b-dropdown-item v-if="$can('view-sales-orders') || $can('view-all')" to="/orders/sales-orders/create">New Order</b-dropdown-item>
                    <b-dropdown-item v-if="$can('view-sales-orders') || $can('view-all')" replace to="/orders/sales-orders/confirmed">Confirmed Orders</b-dropdown-item>
                    <b-dropdown-item v-if="$can('view-sales-orders') || $can('view-all')" replace to="/orders/sales-orders/dispatched">Dispatched Orders</b-dropdown-item>
                    <b-dropdown-item v-if="$can('view-credits') || $can('view-all')" replace to="/orders/creditmemos">Credit Memos</b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item-dropdown id="purchasing" v-if="$can('view-purchasing') || $can('view-all')" text="PURCHASING" no-caret>
                    <b-dropdown-item v-if="$can('view-bills') || $can('view-all')" to="/purchasing/bills">Bills</b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item-dropdown v-if="$can('view-warehousing') || $can('view-all')" text="WAREHOUSING" no-caret>
                    <!-- <b-dropdown-item v-if="$can('view-receiving') || $can('view-all')" to="/warehousing/receiving">Receiving</b-dropdown-item> -->
                    <!-- <b-dropdown-item v-if="$can('view-locations') || $can('view-all')" to="/warehousing/locations">Locations</b-dropdown-item> -->
                    <b-dropdown-item id="stocktransfer" v-if="$can('view-stock-transfer') || $can('view-all')" to="/warehousing/stock-transfer">Stock Transfer</b-dropdown-item>
                    <b-dropdown-item v-if="$can('view-label-generator') || $can('view-all')" to="/warehousing/label-generator">Label Generator</b-dropdown-item>
                    <b-dropdown-item v-if="$can('view-batch-pick') || $can('view-all')" replace to="/warehousing/batch-pick">Batch Pick</b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item-dropdown v-if="$can('view-lists') || $can('view-all')" text="LISTS" no-caret>
                    <b-dropdown-item v-if="$can('view-customers') || $can('view-all')" to="/lists/customers">Customers</b-dropdown-item>
                    <b-dropdown-item v-if="$can('view-customer-review') || $can('view-all')" to="/lists/customers/review">Customer Review</b-dropdown-item>
                    <b-dropdown-item v-if="$can('view-vendors') || $can('view-all')" to="/lists/vendors">Vendors</b-dropdown-item>
                    <!-- <b-dropdown-item v-if="$can('view-sales-reps') || $can('view-all')" to="/lists/sales-reps">Sales Reps</b-dropdown-item> -->
                </b-nav-item-dropdown>

                <b-nav-item-dropdown v-if="$can('view-accounting') || $can('view-all')" text="ACCOUNTING" no-caret>
                    <b-dropdown-item v-if="$can('view-payments') || $can('view-all')" to="/accounting/payments">Payments</b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item-dropdown v-if="$can('view-reporting') || $can('view-all')" text="REPORTING" no-caret>
                    <b-dropdown-item v-if="$can('view-transaction-ledger') || $can('view-all')" to="/reporting/transaction-ledger">Transaction Ledger</b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item-dropdown v-if="$can('view-company') || $can('view-all')" text="COMPANY" no-caret>
                    <b-dropdown-item v-if="$can('view-user-management') || $can('view-all')" to="/company/user-management">User Management</b-dropdown-item>
                    <b-dropdown-item v-if="$can('view-source-management') || $can('view-all')" to="/company/source-management">Source Management</b-dropdown-item>
                </b-nav-item-dropdown>
      		</b-navbar-nav>

      		<!-- Right aligned nav items -->
      		<b-navbar-nav class="ml-auto">
        		<!-- <b-nav-form>
          			<b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
          			<b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
        		</b-nav-form> -->

	        	<b-nav-item-dropdown right>
	          		<!-- Using 'button-content' slot -->
	          		<template v-slot:button-content>
	            		<em v-if="user">{{ user.name }}</em>
	          		</template>
	          		<b-dropdown-item href="#">Profile</b-dropdown-item>
	          		<b-dropdown-item href="#" @click.prevent="$emit('signOut')">Sign Out</b-dropdown-item>
	        	</b-nav-item-dropdown>
	      	</b-navbar-nav>
    	</b-collapse>
 	</b-navbar>
</template>

<script>
  	export default {
  		// props: [ 'authenticated', 'user' ],
        props: [],
        computed: {
            navbarVariant() {
                // If custom color is set, use 'dark' variant but override with custom style
                return this.env.COMPANY_APP_COLOR ? 'dark' : 'dark';
            },
            navbarStyle() {
                if (this.env.COMPANY_APP_COLOR) {
                    const textColor = this.getContrastingTextColor(this.env.COMPANY_APP_COLOR);
                    return {
                        backgroundColor: this.env.COMPANY_APP_COLOR + ' !important',
                        borderColor: this.env.COMPANY_APP_COLOR + ' !important',
                        color: textColor + ' !important'
                    };
                }
                return {};
            }
        },
        methods: {
            getContrastingTextColor(backgroundColor) {
                // Convert color to RGB values
                let rgb;
                
                // Handle hex colors
                if (backgroundColor.startsWith('#')) {
                    const hex = backgroundColor.replace('#', '');
                    const r = parseInt(hex.substr(0, 2), 16);
                    const g = parseInt(hex.substr(2, 2), 16);
                    const b = parseInt(hex.substr(4, 2), 16);
                    rgb = [r, g, b];
                }
                // Handle rgb/rgba colors
                else if (backgroundColor.startsWith('rgb')) {
                    const matches = backgroundColor.match(/\d+/g);
                    if (matches && matches.length >= 3) {
                        rgb = [parseInt(matches[0]), parseInt(matches[1]), parseInt(matches[2])];
                    }
                }
                // Handle named colors
                else {
                    // Create a temporary element to get computed color
                    const temp = document.createElement('div');
                    temp.style.color = backgroundColor;
                    document.body.appendChild(temp);
                    const computedColor = window.getComputedStyle(temp).color;
                    document.body.removeChild(temp);
                    
                    const matches = computedColor.match(/\d+/g);
                    if (matches && matches.length >= 3) {
                        rgb = [parseInt(matches[0]), parseInt(matches[1]), parseInt(matches[2])];
                    }
                }
                
                if (!rgb) {
                    return '#ffffff'; // Default to white if color parsing fails
                }
                
                // Calculate luminance using the relative luminance formula
                // https://www.w3.org/TR/WCAG20/#relativeluminancedef
                const [r, g, b] = rgb.map(c => {
                    c = c / 255;
                    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
                });
                
                const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
                
                // Return black text for light backgrounds, white text for dark backgrounds
                return luminance > 0.5 ? '#000000' : '#ffffff';
            }
        },
        mounted() {
            this.$root.$on("bv::dropdown::shown", (evt) => {
                let currentRoute = this.$router.currentRoute.name
                let dropdownId = evt.id
                if (dropdownId == 'inventory' && currentRoute != 'Products' ) {
                    this.$router.push({ name: 'Products'})
                } else if (dropdownId == 'orders' && currentRoute != 'SalesOrders' ) {
                    this.$router.push({ name: 'SalesOrders'})
                } else if (dropdownId == 'stocktransfer' && currentRoute != 'StockTransfer' ) {
                    this.$router.push({ name: 'StockTransfer'})
                }
            });
        }
  	}
</script>
